<template>
  <div class="admin-email-templates-index p-4 sm:p-6 lg:p-8">
    <!-- Header -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
      <div>
        <h1 class="text-3xl font-bold text-gray-900">Email Templates</h1>
        <p class="text-gray-600 mt-1">Manage email templates used throughout the application</p>
      </div>
    </div>

    <!-- Search -->
    <div class="bg-white rounded-lg shadow-md border border-gray-200 p-4 mb-6">
      <form @submit.prevent="search" class="flex gap-4">
        <input
          v-model="searchQuery"
          type="text"
          placeholder="Search templates..."
          class="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
        />
        <button
          type="submit"
          class="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
        >
          Search
        </button>
      </form>
    </div>

    <!-- Templates Table -->
    <div class="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
      <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Slug</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Language</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Details</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr v-for="template in templates.data" :key="template.id" class="hover:bg-gray-50 transition-colors">
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {{ template.name }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                <code class="px-2 py-1 bg-gray-100 rounded text-xs">{{ template.slug }}</code>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                {{ template.language || '—' }}
              </td>
              <td class="px-6 py-4 text-sm text-gray-600 max-w-md">
                <div class="truncate" v-html="template.details"></div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm">
                <Link
                  :href="route('admin.email-templates.edit', template.id)"
                  class="text-blue-600 hover:text-blue-800 hover:underline"
                >
                  Edit
                </Link>
              </td>
            </tr>
            <tr v-if="templates.data.length === 0">
              <td colspan="5" class="px-6 py-12 text-center">
                <div class="flex flex-col items-center gap-3">
                  <icon name="email" class="w-16 h-16 text-gray-300" />
                  <p class="text-gray-500 text-lg font-medium">No templates found</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div v-if="templates.links && templates.links.length > 3" class="bg-gray-50 px-4 py-3 border-t border-gray-200 flex items-center justify-between">
        <div class="text-sm text-gray-700">
          Showing {{ templates.from }} to {{ templates.to }} of {{ templates.total }} results
        </div>
        <div class="flex gap-2">
          <Link
            v-for="link in templates.links"
            :key="link.label"
            :href="link.url || '#'"
            v-html="link.label"
            :class="[
              'px-4 py-2 rounded-lg text-sm font-medium transition-colors',
              link.active
                ? 'bg-green-600 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300',
              !link.url ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
            ]"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link, router } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon.vue'
import Layout from '@/Shared/Layout'

export default {
  layout: Layout,
  components: {
    Link,
    Icon,
  },
  props: {
    templates: {
      type: Object,
      required: true,
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: 'Email Templates',
    },
  },
  data() {
    return {
      searchQuery: this.filters.search || '',
    }
  },
  methods: {
    search() {
      router.get(route('admin.email-templates.index'), { search: this.searchQuery }, {
        preserveState: true,
        preserveScroll: true,
      })
    },
  },
}
</script>

<style scoped>
.admin-email-templates-index {
  min-height: 100vh;
  background-color: #f9fafb;
}
</style>



